import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import "./UserForm.css";
import "./FrequencyConfig.css";
import "./EquipmentTypeVariantForm.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import Select, { components } from "react-select";
import { CiCirclePlus } from "react-icons/ci";
import AddDepartmentPopup from "../Popups/AddDepartmentPopup";
import AddEquipmentType from "../Popups/AddEquipmentType";
import AddEquipmentSubType from "../Popups/AddEquipmentSubType";
import AddSubTypeVariant from "../Popups/AddSubTypeVariant";
import AddSubDepartmentPopup from "../Popups/AddSubDepartmentPopup";
import { FaPlusCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Tabs, Tab } from "@mui/material";
import { useContext } from "react";
import { ThemeContext } from "../../src/ThemeContext";
const { Control, Menu } = components;

function FrequencyConfig({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const [equipmentSubTypes, setEquipmentSubTypes] = useState([]);
  const [equipmentSubTypeVariants, setEquipmentTypeVariants] = useState([]);
  const [severity, setSeverity] = useState("success");
  const [
    EquipmentSubTypeVariantsMenuIsOpen,
    setEquipmentSubTypeVariantsMenuIsOpen,
  ] = useState(false);
  const [showSubTypeVariantPopup, setShowSubTypeVariantPopup] = useState(false);
  const [selectedEquipmentSubType, setSelectedEquipmentSubType] =
    useState(null);
  const [EquipmentSubTypeMenuIsOpen, setEquipmentSubTypeMenuIsOpen] =
    useState(false);
  const [tabValue, setTabValue] = useState(0); // State for tab navigation
  const containerRef = useRef(null);
  const [equipmentSubTypeVariantData, setEquipmentSubTypeVariantData] =
    useState({
      EquipmentSubType: "",
      EquipmentSubTypeId: "",
      SubTypeVariant: null,
      VariantNameId: "",
      oisd_frequencies: [
        { OISDPoint: "", Frequency: "", Description: "", category: "" },
      ],
      car_frequencies: [
        { car_point: "", Frequency: "", car_description: "", category: "" },
      ],
      factory_act_frequencies: [{ factory_act_rule_no: "", Frequency: "" }],
      oem_frequencies: [{ Frequency: "" }],
      peso_frequencies: [{ peso_rule_no: "", Frequency: "" }],
      DepartmentId: "",
      DepartmentName: "",
      EquipmentType: "",
      EquipmentTypeId: "",
      SubDepartmentId: "",
      SubDepartmentName: "",
      // oisd_no: "",
    });
  const [showSubTypePopup, setShowSubTypePopup] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [equipmentTypes, setEquipmentTypes] = useState([]);
  const [selectedSubDepartmentId, setSelectedSubDepartmentId] = useState(null);
  const [currentOpenPopup, setCurrentOpenPopup] = useState(null);
  const [selectedEquipmentTypes, setSelectEdequipmentType] = useState(null);
  const [showequipmentTypePopup, setShowequipmentTypePopup] = useState(false);
  const [EquipmentTypeMenuIsOpen, setEquipmentTypeMenuIsOpen] = useState(false);
  const [showDepartmentPopup, setShowDepartmentPopup] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [subDepartments, setSubDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedEquipmentSubTypeVariants, setSelectEdequipmentTypeVariants] =
    useState(null);
  const [departments, setDepartments] = useState([]);
  const [departmentError, setDepartmentError] = useState("");
  const [selectedSubDepartment, setSelectedSubDepartment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);
  const [subDepartmentMenuIsOpen, setSubDepartmentMenuIsOpen] = useState(false);
  const [category, setCategory] = useState([]);
  const [showSubDepartmentPopup, setShowSubDepartmentPopup] = useState(false);
  const { theme } = useContext(ThemeContext);
  const handleKeyDown = (event) => {
    if (event.key === "Backspace" && !inputValue && selectedDepartment) {
      setSelectedDepartment(null);
    }
  };
  const projectType = localStorage.getItem("project_type");
  console.log("projectType", projectType);

  const fetchCategory = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_all_product_library_details`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        const productLibraryTypes = responseData.product_library_details;

        if (productLibraryTypes && productLibraryTypes.length > 0) {
          // Map the product library details to options for the Select dropdown
          const options = productLibraryTypes.map((type) => ({
            label: `${type.library_name}-${type.doc_name}`, // Label for dropdown
            value: type.file_id, // Value for dropdown selectio
            library_id: type.library_id,
          }));
          setCategory(options); // Set the transformed options to category state
        } else {
          console.error("No product library types found in the response");
        }
      } else {
        console.error(
          "Failed to fetch product library types, status:",
          response.status
        );
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching product library types:",
        error
      );
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handlecategoryChange = (selectedOption, index) => {
    const updatedFrequencies = [
      ...equipmentSubTypeVariantData.oisd_frequencies,
    ];
    updatedFrequencies[index].category = selectedOption; // Update the category for the specific index
    setEquipmentSubTypeVariantData({
      ...equipmentSubTypeVariantData,
      oisd_frequencies: updatedFrequencies,
    });
  };

  const handleCARcategoryChange = (selectedOption, index) => {
    const updatedFrequencies = [...equipmentSubTypeVariantData.car_frequencies];
    updatedFrequencies[index].category = selectedOption; // Update the category for the specific index
    setEquipmentSubTypeVariantData({
      ...equipmentSubTypeVariantData,
      car_frequencies: updatedFrequencies,
    });
  };

  const handleKeyDownEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };

  const closeEquipmentTypePopup = () => {
    setShowequipmentTypePopup(false);
  };

  const CustomSubControl = ({ children, ...props }) => (
    <Control {...props}>{children}</Control>
  );
  const CustomSubMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={handleAddNewSubType}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add Equipment Sub Type
      </button>
    </Menu>
  );

  const CustomVariantControl = ({ children, ...props }) => (
    <Control {...props}>{children}</Control>
  );
  const CustomVariantMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={handleAddNewTypeVariant}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add Equipment Sub Type Variant
      </button>
    </Menu>
  );

  const handleAddNewTypeVariant = () => {
    setShowSubTypeVariantPopup(true);
    setEquipmentSubTypeVariantsMenuIsOpen(false);
  };
  const handleNewEquipmentSubTypeVariant = (newSubTypeVariant) => {
    setEquipmentTypeVariants((prevEquipmentTypeVariants) => [
      ...prevEquipmentTypeVariants,
      newSubTypeVariant,
    ]);
    setSelectEdequipmentTypeVariants(newSubTypeVariant);
    setEquipmentSubTypeVariantData((prevEquipmentTypeVariants) => ({
      ...prevEquipmentTypeVariants,
      SubTypeVariant: newSubTypeVariant.label,
      VariantNameId: newSubTypeVariant.value,
    }));
    showSnackbar("Equipment sub type variant added successsfully");
  };
  const closeEquipmentTypeVariantPopup = () => {
    setShowSubTypeVariantPopup(false);
  };

  const handleSubDepartmentKeyDown = (event) => {
    if (event.key === "Backspace" && !inputValue && selectedSubDepartment) {
      setSelectedSubDepartment(null);
    }
  };

  const handleTypeKeyDown = (event) => {
    if (event.key === "Backspace" && !inputValue && selectedEquipmentTypes) {
      setSelectEdequipmentType(null);
    }
  };
  const handleSubTypeKeyDown = (event) => {
    if (event.key === "Backspace" && !inputValue && selectedEquipmentSubType) {
      setSelectedEquipmentSubType(null);
    }
  };
  const handleTypeVariantsKeyDown = (event) => {
    if (
      event.key === "Backspace" &&
      !inputValue &&
      selectedEquipmentSubTypeVariants
    ) {
      setSelectEdequipmentTypeVariants(null);
    }
  };

  const closeSubDepartmentPopup = (newSubDepartment) => {
    setShowSubDepartmentPopup(false);
    fetchSubDepartments();
    if (newSubDepartment) {
      // If a new sub-department is added
      const updatedSubDepartment = {
        label: newSubDepartment.SubDepartment,
        value: newSubDepartment.id,
      };
      setSelectedSubDepartment(updatedSubDepartment);
    }
  };

  const handleNewEquipmentType = (newEquipment) => {
    setEquipmentTypes((prevEquipmentTypes) => [
      ...prevEquipmentTypes,
      newEquipment,
    ]);
    setSelectEdequipmentType(newEquipment);
    setEquipmentSubTypeVariantData((prevEquipmentSubTypes) => ({
      ...prevEquipmentSubTypes,
      EquipmentType: newEquipment.label,
      EquipmentTypeId: newEquipment.value,
    }));
    showSnackbar("Equipment type added successsfully");
  };

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
  };

  const handleCancelClick = () => {
    navigate("/frequency");
  };

  const CustomSubDepartmentControl = ({ children, ...props }) => (
    <Control {...props}>{children}</Control>
  );
  const CustomSubDepartmentMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={handleAddNewSubDepartment}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add New Sub Department
      </button>
    </Menu>
  );
  const handleAddNewSubDepartment = () => {
    setShowSubDepartmentPopup(true);
    setSubDepartmentMenuIsOpen(false);
  };

  const CustomTypeControl = ({ children, ...props }) => (
    <Control {...props}>{children}</Control>
  );
  const CustomTypeMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={handleAddEquipmentType}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add Equipment Type
      </button>
    </Menu>
  );
  const CustomControl = ({ children, ...props }) => (
    <Control {...props}>{children}</Control>
  );
  const CustomMenu = ({ children, ...props }) => (
    <Menu {...props}>
      {children}
      <button
        type="button"
        className="add-company-button"
        onClick={handleAddNewDepartment}
      >
        <CiCirclePlus className="new-plus-circle" />
        Add New Department
      </button>
    </Menu>
  );

  const handleAddNewDepartment = () => {
    setShowDepartmentPopup(true);
    setDepartmentMenuIsOpen(false);
  };

  const handleAddEquipmentType = () => {
    setShowequipmentTypePopup(true);
    setEquipmentTypeMenuIsOpen(false);
  };

  const handleDepartmentMenuOpen = () => {
    closeAllPopups();
    setDepartmentMenuIsOpen(true);
    setCurrentOpenPopup("department");
  };

  const closeAllPopups = () => {
    setDepartmentMenuIsOpen(false);
    setSubDepartmentMenuIsOpen(false);
    setEquipmentTypeMenuIsOpen(false);
    setEquipmentSubTypeMenuIsOpen(false);
  };

  const handleAddFrequencyRow = () => {
    setEquipmentSubTypeVariantData((prevData) => ({
      ...prevData,
      oisd_frequencies: [
        ...prevData.oisd_frequencies,
        { OISDPoint: "", Frequency: "", Description: "" },
      ],
    }));
  };

  const handleAddCARFrequencyRow = () => {
    setEquipmentSubTypeVariantData((prevData) => ({
      ...prevData,
      car_frequencies: [
        ...prevData.car_frequencies,
        { car_point: "", Frequency: "", car_description: "" },
      ],
    }));
  };

  // Add a new Factory Act frequency row
  const handleAddFactoryActRow = () => {
    setEquipmentSubTypeVariantData((prevData) => ({
      ...prevData,
      factory_act_frequencies: [
        ...prevData.factory_act_frequencies,
        { factory_act_rule_no: "", Frequency: "" },
      ],
    }));
  };
  const handleAddOEMRow = () => {
    setEquipmentSubTypeVariantData((prevData) => ({
      ...prevData,
      oem_frequencies: [...prevData.oem_frequencies, { Frequency: "" }],
    }));
  };
  const handleAddPESORow = () => {
    setEquipmentSubTypeVariantData((prevData) => ({
      ...prevData,
      peso_frequencies: [
        ...prevData.peso_frequencies,
        { peso_rule_no: "", Frequency: "" },
      ],
    }));
  };

  const handleCloseFrequencyRow = (index) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const newFrequencies = prevData.oisd_frequencies.filter(
        (_, i) => i !== index
      );
      return { ...prevData, oisd_frequencies: newFrequencies };
    });
  };

  const handleCloseCARRow = (index) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const newFrequencies = prevData.car_frequencies.filter(
        (_, i) => i !== index
      );
      return { ...prevData, car_frequencies: newFrequencies };
    });
  };

  // Remove a Factory Act frequency row
  const handleCloseFectoryActRow = (index) => {
    console.log("indexindexindex", index);
    setEquipmentSubTypeVariantData((prevData) => {
      const newFrequencies = prevData.factory_act_frequencies.filter(
        (_, i) => i !== index
      );
      return { ...prevData, factory_act_frequencies: newFrequencies };
    });
  };

  const handleCloseOEMRow = (index) => {
    console.log("indexindexindex", index);
    setEquipmentSubTypeVariantData((prevData) => {
      const newFrequencies = prevData.oem_frequencies.filter(
        (_, i) => i !== index
      );
      return { ...prevData, oem_frequencies: newFrequencies };
    });
  };

  const handleClosePesoRow = (index) => {
    console.log("indexindexindex", index);
    setEquipmentSubTypeVariantData((prevData) => {
      const newFrequencies = prevData.peso_frequencies.filter(
        (_, i) => i !== index
      );
      return { ...prevData, peso_frequencies: newFrequencies };
    });
  };

  const fetchDepartment = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_departments`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });
      if (response.ok) {
        const data = await response.json();
        const options = data.map((department) => ({
          label: department.DepartmentName,
          value: department.ID,
        }));
        setDepartments(options);
      } else {
        console.error("Failed to fetch departments");
      }
    } catch (error) {
      console.error("An error occurred while fetching departments:", error);
    }
  };

  const closeDepartmentPopup = () => {
    setShowDepartmentPopup(false);
  };

  const handleNewDepartment = (newDepartment) => {
    if (newDepartment) {
      setDepartments((prevDepartments) => [...prevDepartments, newDepartment]);
      setSelectedDepartment(newDepartment);
      setEquipmentSubTypeVariantData((prevFormData) => ({
        ...prevFormData,
        DepartmentName: newDepartment.label,
        DepartmentId: newDepartment.value,
      }));
      showSnackbar("Department added successfully");
    }
  };

  useEffect(() => {
    fetchDepartment();
  }, []);
  const fetchSubDepartments = async () => {
    try {
      if (selectedDepartment) {
        const authKey = localStorage.getItem("authKey");
        const apiUrl = `${API_URL}/api/get_sub_department/${selectedDepartment.value}`;
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: authKey,
          },
        });
        if (response.ok) {
          const data = await response.json();
          const options = data.map((subDepartment) => ({
            label: subDepartment.Name,
            value: subDepartment.id,
          }));
          setSubDepartments(options);
        } else {
          console.error("Failed to fetch sub-departments");
        }
      } else {
        setSubDepartments([]);
      }
    } catch (error) {
      console.error("An error occurred while fetching sub-departments:", error);
    }
  };

  useEffect(() => {
    if (selectedDepartment) {
      fetchSubDepartments();
      setSelectedSubDepartment(null);
    } else {
      setSubDepartments([]);
      setSelectedSubDepartment(null);
    }
  }, [selectedDepartment]);

  const handleSubDepartmentChange = (selectedOption) => {
    setSelectedSubDepartment(selectedOption);
    setEquipmentSubTypeVariantData((prevFormData) => ({
      ...prevFormData,
      SubDepartmentName: selectedOption.label,
      SubDepartmentId: selectedOption.value,
    }));
    fetchEquipmentTypes(selectedOption.value);
    setSelectEdequipmentType(null);
    setSelectedEquipmentSubType(null);
    setSelectEdequipmentTypeVariants(null);
  };

  const handleEquipmentTypeChange = (selectedOption) => {
    setSelectEdequipmentType(selectedOption);
    setEquipmentSubTypeVariantData((prevFormData) => ({
      ...prevFormData,
      EquipmentType: selectedOption.label,
      EquipmentTypeId: selectedOption.value,
    }));
    fetchEquipmentSubType(selectedOption.value);
    setSelectedEquipmentSubType(null);
    setSelectEdequipmentTypeVariants(null);
  };

  const handleDepartmentChange = (selectedOption) => {
    setSelectedDepartment(selectedOption);
    setEquipmentSubTypeVariantData((prevFormData) => ({
      ...prevFormData,
      DepartmentName: selectedOption.label,
      DepartmentId: selectedOption.value,
    }));
    fetchSubDepartments(selectedOption.value);
    setSelectedSubDepartment(null);
    setSelectEdequipmentType(null);
    setSelectedEquipmentSubType(null);
    setDepartmentError("");
  };

  const handleEquipmentTypeMenuOpen = () => {
    closeAllPopups();
    setEquipmentTypeMenuIsOpen(true);
    setCurrentOpenPopup("equipmentType");
  };

  const handleTypeSubTypeVariantsChange = (selectedOption) => {
    setSelectEdequipmentTypeVariants(selectedOption);
    setEquipmentSubTypeVariantData((prevFormData) => ({
      ...prevFormData,
      SubTypeVariant: selectedOption.label,
      VariantNameId: selectedOption.value,
    }));
  };

  const handleSubDepartmentMenuOpen = () => {
    closeAllPopups();
    setSubDepartmentMenuIsOpen(true);
    setCurrentOpenPopup("subDepartment");
  };

  const fetchEquipmentTypes = async (subDepartmentId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_equipment_types_by_sub_department/${subDepartmentId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });
      if (response.ok) {
        const data = await response.json();
        const options = data.map((equipmentType) => ({
          label: equipmentType.EquipmentType,
          value: equipmentType.id,
        }));
        setEquipmentTypes(options);
      } else {
        console.error("Failed to fetch Equipment Types");
      }
    } catch (error) {
      console.error("An error occurred while fetching Equipment Types:", error);
    }
  };

  const fetchEquipmentSubTypeVariants = async (equipmentSubTypeId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_sub_type_variants_by_sub_type/${equipmentSubTypeId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });
      if (response.ok) {
        const data = await response.json();
        const options = data.map((equipmentSubTypeVariant) => ({
          label: equipmentSubTypeVariant.VariantName,
          value: equipmentSubTypeVariant.id,
        }));
        setEquipmentTypeVariants(options);
      } else {
        console.error("Failed to fetch Equipment Sub Type Variants");
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching Equipment Sub Type Variants:",
        error
      );
    }
  };

  useEffect(() => {
    if (selectedEquipmentSubType) {
      fetchEquipmentSubTypeVariants(selectedEquipmentSubType.value);
    }
  }, [selectedEquipmentSubType]);

  useEffect(() => {
    if (selectedSubDepartmentId) {
      fetchEquipmentTypes(selectedSubDepartmentId);
    }
  }, [selectedSubDepartmentId]);

  const handleSaveClick = async () => {
    setDepartmentError("");

    // Validate department selection
    if (!selectedDepartment) {
      setDepartmentError("Department is required");
      return;
    }

    // Filter out empty OISD frequency rows (without using trim)
    const filteredOisdFrequencies =
      equipmentSubTypeVariantData.oisd_frequencies.filter(
        (frequency) =>
          frequency.OISDPoint !== "" ||
          frequency.Frequency !== "" ||
          frequency.Description !== "" ||
          (frequency.oisd_no && frequency.oisd_no !== "")
      );

    // Assign `frequency_type: 'oisd'` to each OISD frequency
    const updatedOisdFrequencies = filteredOisdFrequencies.map((frequency) => ({
      ...frequency,
      frequency_type: "oisd", // Set frequency type to oisd
      doc_file_id: frequency.category ? frequency.category.value : "", // Extract only the value from category
      doc_library_id: frequency.category ? frequency.category.library_id : "",
    }));

    const filteredCarFrequencies =
      equipmentSubTypeVariantData.car_frequencies.filter(
        (frequency) =>
          frequency.car_point !== "" ||
          frequency.Frequency !== "" ||
          frequency.car_description !== "" ||
          (frequency.car_rule_no && frequency.car_rule_no !== "")
      );
    const updatedCarFrequencies = filteredCarFrequencies.map((frequency) => ({
      ...frequency,
      frequency_type: "AQCAM", // Set frequency type to car
      doc_file_id: frequency.category ? frequency.category.value : "", // Extract only the value from category
      doc_library_id: frequency.category ? frequency.category.library_id : "",
    }));

    // Filter out empty Factory Act frequency rows (without using trim)
    const filteredFactoryActFrequencies =
      equipmentSubTypeVariantData.factory_act_frequencies.filter(
        (frequency) =>
          frequency.factory_act_rule_no !== "" || frequency.Frequency !== ""
      );

    // Assign `frequency_type: 'factory_act'` to each Factory Act frequency
    const updatedFactoryActFrequencies = filteredFactoryActFrequencies.map(
      (frequency) => ({
        ...frequency,
        frequency_type: "factory_act", // Set frequency type to factory_act
      })
    );

    // const filteredATFFrequencies =
    //   equipmentSubTypeVariantData.atf_frequencies.filter(
    //     (frequency) =>
    //       frequency.atf_rule_no !== "" || frequency.Frequency !== ""
    //   );

    // const updatedATFFrequencies = filteredATFFrequencies.map((frequency) => ({
    //   ...frequency,
    //   frequency_type: "atf",
    // }));

    const filteredOEMFrequencies =
      equipmentSubTypeVariantData.oem_frequencies.filter(
        (frequency) => frequency.Frequency !== ""
      );

    // Assign `frequency_type: 'factory_act'` to each Factory Act frequency
    const updatedOEMFrequencies = filteredOEMFrequencies.map((frequency) => ({
      ...frequency,
      frequency_type: "oem", // Set frequency type to factory_act
    }));

    const filteredPESOFrequencies =
      equipmentSubTypeVariantData.peso_frequencies.filter(
        (frequency) => frequency.Frequency !== ""
      );

    // Assign `frequency_type: 'factory_act'` to each Factory Act frequency
    const updatedPESOFrequencies = filteredPESOFrequencies.map((frequency) => ({
      ...frequency,
      frequency_type: "peso", // Set frequency type to factory_act
    }));

    // Create a new data object with the updated frequencies
    const updatedSubTypeVariantData = {
      ...equipmentSubTypeVariantData,
      oisd_frequencies: updatedOisdFrequencies, // Update OISD frequencies with type
      factory_act_frequencies: updatedFactoryActFrequencies,
      oem_frequencies: updatedOEMFrequencies, // Update Factory Act frequencies with type
      peso_frequencies: updatedPESOFrequencies,
      // atf_frequencies: updatedATFFrequencies,
      car_frequencies: updatedCarFrequencies,
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      // Make the API request with the updated data
      const response = await axios.post(
        `${API_URL}/api/add_frequency_config`,
        updatedSubTypeVariantData,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      console.log(response.data.message);
      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Frequency configuration added successfully");
        setTimeout(() => {
          navigate("/frequency");
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      // Handle error (e.g., show an error message to the user)
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleEquipmentSubTypeMenuOpen = () => {
    setEquipmentSubTypeMenuIsOpen(true);
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // const CustomControl = ({ children, ...props }) => (
  //   <Control {...props}>{children}</Control>
  // );
  // const CustomMenu = ({ children, ...props }) => (
  //   <Menu {...props}>
  //     {children}
  //     <button
  //       type="button"
  //       className="add-company-button"
  //       onClick={handleAddNewSubType}
  //     >
  //       <CiCirclePlus className="new-plus-circle" />
  //       Add Equipment Sub Type
  //     </button>
  //   </Menu>
  // );
  const handleAddNewSubType = () => {
    setShowSubTypePopup(true);
    setEquipmentSubTypeMenuIsOpen(false);
  };

  const handleNewSubDepartment = (newSubDepartment) => {
    setSubDepartments((prevSubDepartments) => [
      ...prevSubDepartments,
      newSubDepartment,
    ]);
    setSelectedSubDepartment(newSubDepartment);
    setEquipmentSubTypeVariantData((prevSubDepartments) => ({
      ...prevSubDepartments,
      SubDepartmentName: newSubDepartment.label,
      SubDepartmentId: newSubDepartment.value,
    }));

    showSnackbar("Sub Department added successfully");
  };
  const closeSubTypePopup = (newSubType) => {
    setShowSubTypePopup(false);
    if (newSubType) {
      setEquipmentSubTypes((prevDepartments) => [
        ...prevDepartments,
        newSubType,
      ]);
      setSelectedEquipmentSubType(newSubType);
      setEquipmentSubTypeVariantData((prevFormData) => ({
        ...prevFormData,
        EquipmentSubType: newSubType.label,
        EquipmentSubTypeId: newSubType.value,
      }));
    }
  };

  const handleTypeSubTypeChange = (selectedOption) => {
    setSelectedEquipmentSubType(selectedOption);
    setEquipmentSubTypeVariantData((prevFormData) => ({
      ...prevFormData,
      EquipmentSubType: selectedOption.label,
      EquipmentSubTypeId: selectedOption.value,
    }));
  };

  // const handleNewEquipmentSubType = (newSubEquipment) => {
  //   setEquipmentSubTypes((prevEquipmentSubTypes) => [
  //     ...prevEquipmentSubTypes,
  //     newSubEquipment,
  //   ]);

  //   const updatedEquipmentSubType = {
  //     label: newSubEquipment.label,
  //     value: newSubEquipment.value,
  //   };

  //   setSelectedEquipmentSubType(updatedEquipmentSubType);
  // };

  const handleNewEquipmentSubType = (newSubEquipment) => {
    setEquipmentSubTypes((prevEquipmentSubTypes) => [
      ...prevEquipmentSubTypes,
      newSubEquipment,
    ]);
    setSelectedEquipmentSubType(newSubEquipment);
    setEquipmentSubTypeVariantData((prevEquipmentSubTypes) => ({
      ...prevEquipmentSubTypes,
      EquipmentSubType: newSubEquipment.label,
      EquipmentSubTypeId: newSubEquipment.value,
    }));
    showSnackbar("Equipment type added successsfully");
  };

  const fetchEquipmentSubType = async (EquipmentTypeId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_equipment_sub_types_by_type/${EquipmentTypeId}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });

      if (response.ok) {
        const data = await response.json();
        // Map the API response to the format expected by react-select
        const options = data.map((equipmentSubType) => ({
          label: equipmentSubType.EquipmentSubType,
          value: equipmentSubType.id,
        }));
        setEquipmentSubTypes(options);
      } else {
        console.error("Failed to fetch Equipment Type");
      }
    } catch (error) {
      console.error("An error occurred while fetching Equipment Type:", error);
    }
  };
  useEffect(() => {
    fetchEquipmentSubType();
  }, []);

  const handleFrequencyChange = (index, field, value) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const updatedFrequencies = [...prevData.oisd_frequencies];
      updatedFrequencies[index][field] = value;
      return { ...prevData, oisd_frequencies: updatedFrequencies };
    });
  };

  const handleCARFrequencyChange = (index, field, value) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const updatedFrequencies = [...prevData.car_frequencies];
      updatedFrequencies[index][field] = value;
      return { ...prevData, car_frequencies: updatedFrequencies };
    });
  };

  // Handle changes in Factory Act frequencies
  const handleFectoryActChange = (index, field, value) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const updatedFrequencies = [...prevData.factory_act_frequencies];
      updatedFrequencies[index][field] = value;
      return { ...prevData, factory_act_frequencies: updatedFrequencies };
    });
  };
  const handleOEMChange = (index, field, value) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const updatedFrequencies = [...prevData.oem_frequencies];
      updatedFrequencies[index][field] = value;
      return { ...prevData, oem_frequencies: updatedFrequencies };
    });
  };

  const handlePESOChange = (index, field, value) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const updatedFrequencies = [...prevData.peso_frequencies];
      updatedFrequencies[index][field] = value;
      return { ...prevData, peso_frequencies: updatedFrequencies };
    });
  };
  const handleRemoveFrequencyRow = (index) => {
    setEquipmentSubTypeVariantData((prevData) => {
      const updatedFrequencies = prevData.Frequencies.filter(
        (_, i) => i !== index
      );
      return { ...prevData, Frequencies: updatedFrequencies };
    });
  };

  const tabs = ["OISD", "Factory Act", "OEM Recommendation", "PESO", "AQCAM"];

  const tabStyles = {
    container: {
      width: "100%",
      fontFamily: "Inter, sans-serif",
    },
    tabHeader: {
      display: "flex",
      width: "100%",
      borderBottom: "2px solid #e0e0e0",
      backgroundColor: "#f9f9f9",
    },
    tab: (active) => ({
      flex: 1,
      textAlign: "center",
      padding: "12px 0",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: 500,
      color: active ? "#0d6efd" : "#6c757d",
      borderBottom: active ? "3px solid #0d6efd" : "3px solid transparent",
      backgroundColor: active ? "#fff" : "transparent",
      transition: "all 0.3s ease",
    }),
    tabContent: {
      padding: "16px",
      backgroundColor: "#fff",
      border: "1px solid #e0e0e0",
      borderTop: "none",
      borderRadius: "0 0 6px 6px",
    },
  };

  const styles = {
    container: {
      marginBottom: "1.5rem",
      fontFamily: "Arial, sans-serif",
    },
    label: {
      display: "block",
      marginBottom: "6px",
      fontWeight: "bold",
      color: "#333",
    },
    tabs: {
      display: "flex",
      borderBottom: "2px solid #ccc",
      marginBottom: "1rem",
    },
    tab: (isActive) => ({
      padding: "10px 16px",
      cursor: "pointer",
      borderBottom: isActive ? "3px solid #007bff" : "3px solid transparent",
      backgroundColor: isActive ? "#e6f0ff" : "transparent",
      fontWeight: isActive ? "bold" : "normal",
    }),
    card: {
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "1rem",
      backgroundColor: "#fff",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    },
    input: {
      padding: "8px",
      width: "100%",
      marginBottom: "1rem",
      border: "1px solid #ccc",
      borderRadius: "4px",
    },
    rowGroup: {
      display: "flex",
      gap: "1rem",
      flexWrap: "wrap",
    },
    textarea: {
      width: "100%",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      resize: "none",
      marginBottom: "1rem",
    },
    button: {
      padding: "8px 14px",
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    closeButton: {
      backgroundColor: "transparent",
      border: "none",
      color: "red",
      cursor: "pointer",
      fontSize: "16px",
      marginLeft: "10px",
    },
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">Frequency configuration</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail" onKeyDown={handleKeyDownEnter}>
              <div className="new-data-form">
                {/* <div className="form-group-select">
                  <label htmlFor="Department">
                    Department
                  </label>
                  <Select
                    id="department"
                    options={departments}
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    components={{ Control: CustomControl, Menu: CustomMenu }}
                    placeholder="Select Department"
                    isSearchable
                    menuIsOpen={departmentMenuIsOpen}
                    onMenuOpen={handleDepartmentMenuOpen}
                    onMenuClose={() => setDepartmentMenuIsOpen(false)}
                  />
                </div> */}
                <div className="form-group-select">
                  <label htmlFor="Department">
                    Department<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="department"
                    options={departments}
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    onInputChange={handleInputChange}
                    components={{ Control: CustomControl, Menu: CustomMenu }}
                    placeholder="Select Department"
                    isSearchable
                    onKeyDown={handleKeyDown}
                    menuIsOpen={departmentMenuIsOpen}
                    onMenuOpen={handleDepartmentMenuOpen}
                    onMenuClose={() => setDepartmentMenuIsOpen(false)}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                        border: `1px solid ${
                          theme === "dark" ? "#444" : "#ccc"
                        }`, // Border for the menu
                        borderRadius: "4px", // Optional: add border radius for rounded edges
                        zIndex: 1000, // Ensures the menu appears above other elements
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />
                  {departmentError && (
                    <span className="error-message">{departmentError}</span>
                  )}
                </div>

                <div className="form-group-select">
                  <label htmlFor="SubDepartment">Sub Department</label>
                  <Select
                    id="subDepartment"
                    options={subDepartments}
                    value={selectedSubDepartment}
                    onChange={handleSubDepartmentChange}
                    components={{
                      Control: CustomSubDepartmentControl,
                      Menu: CustomSubDepartmentMenu,
                    }}
                    placeholder="Select Sub Department"
                    isSearchable
                    onKeyDown={handleSubDepartmentKeyDown}
                    onInputChange={handleInputChange}
                    menuIsOpen={subDepartmentMenuIsOpen}
                    onMenuOpen={handleSubDepartmentMenuOpen}
                    onMenuClose={() => setSubDepartmentMenuIsOpen(false)}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                        border: `1px solid ${
                          theme === "dark" ? "#444" : "#ccc"
                        }`, // Border for the menu
                        borderRadius: "4px", // Optional: add border radius for rounded edges
                        zIndex: 1000, // Ensures the menu appears above other elements
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />
                </div>
                <div className="form-group-select">
                  <label htmlFor="EquipmentType">Equipment Type </label>

                  <Select
                    id="EquipmentType"
                    options={equipmentTypes}
                    value={selectedEquipmentTypes}
                    onChange={handleEquipmentTypeChange}
                    components={{
                      Control: CustomTypeControl,
                      Menu: CustomTypeMenu,
                    }}
                    placeholder="Select Equipment Type"
                    isSearchable
                    onKeyDown={handleTypeKeyDown}
                    onInputChange={handleInputChange}
                    menuIsOpen={EquipmentTypeMenuIsOpen}
                    onMenuOpen={handleEquipmentTypeMenuOpen}
                    onMenuClose={() => setEquipmentTypeMenuIsOpen(false)}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                        border: `1px solid ${
                          theme === "dark" ? "#444" : "#ccc"
                        }`, // Border for the menu
                        borderRadius: "4px", // Optional: add border radius for rounded edges
                        zIndex: 1000, // Ensures the menu appears above other elements
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />
                </div>
                <div className="form-group-select">
                  <label htmlFor="EquipmentSubType">Sub Type</label>

                  <Select
                    id="EquipmentSubType"
                    options={equipmentSubTypes}
                    value={selectedEquipmentSubType}
                    onChange={handleTypeSubTypeChange}
                    components={{
                      Control: CustomSubControl,
                      Menu: CustomSubMenu,
                    }}
                    placeholder="Select Sub Type"
                    isSearchable
                    onKeyDown={handleSubTypeKeyDown}
                    onInputChange={handleInputChange}
                    menuIsOpen={EquipmentSubTypeMenuIsOpen}
                    onMenuOpen={handleEquipmentSubTypeMenuOpen}
                    onMenuClose={() => setEquipmentSubTypeMenuIsOpen(false)}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                        border: `1px solid ${
                          theme === "dark" ? "#444" : "#ccc"
                        }`, // Border for the menu
                        borderRadius: "4px", // Optional: add border radius for rounded edges
                        zIndex: 1000, // Ensures the menu appears above other elements
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />
                </div>
                <div className="form-group-select">
                  <label htmlFor="ContactNo">Sub Type Variant</label>

                  <Select
                    id="EquipmentSubTypeVariant"
                    options={equipmentSubTypeVariants}
                    onKeyDown={handleTypeVariantsKeyDown}
                    onInputChange={handleInputChange}
                    components={{
                      Control: CustomVariantControl,
                      Menu: CustomVariantMenu,
                    }}
                    value={selectedEquipmentSubTypeVariants}
                    onChange={handleTypeSubTypeVariantsChange}
                    placeholder="Select Sub Type Variants"
                    isSearchable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                        border: `1px solid ${
                          theme === "dark" ? "#444" : "#ccc"
                        }`, // Border for the menu
                        borderRadius: "4px", // Optional: add border radius for rounded edges
                        zIndex: 1000, // Ensures the menu appears above other elements
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />
                </div>

                {/* <div style={tabStyles.container}>
                  <div style={tabStyles.tabHeader}>
                    {tabs.map((tab, index) => (
                      <div
                        key={index}
                        onClick={() => setTabValue(index)}
                        style={tabStyles.tab(tabValue === index)}
                      >
                        {tab}
                      </div>
                    ))}
                  </div>

                  <div style={tabStyles.tabContent}>
                    <h5>{tabs[tabValue]} Content</h5>
                    <p>
                      This is the content for <strong>{tabs[tabValue]}</strong>{" "}
                      tab, styled in Velzon's look.
                    </p>
                  </div>
                </div> */}

                {/* <div style={styles.container}>
                  <label htmlFor="ContactNo" style={styles.label}>
                    Frequency Type
                  </label>

                  <div style={styles.tabs}>
                    {[
                      "OISD",
                      "Factory Act",
                      "OEM Recommendation",
                      "PESO",
                      "CAR",
                    ].map((label, index) => (
                      <div
                        key={index}
                        onClick={() => handleTabChange({}, index)}
                        style={styles.tab(tabValue === index)}
                      >
                        {label}
                      </div>
                    ))}
                  </div>

                  {tabValue === 0 &&
                    equipmentSubTypeVariantData.oisd_frequencies.map(
                      (frequency, index) => (
                        <div key={index} style={styles.card}>
                          <label style={styles.label}>OISD No</label>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="text"
                              name="oisd_no"
                              value={frequency.oisd_no}
                              onChange={(e) =>
                                handleFrequencyChange(
                                  index,
                                  "oisd_no",
                                  e.target.value
                                )
                              }
                              placeholder="Enter OISD no"
                              style={styles.input}
                            />
                            <button
                              type="button"
                              style={styles.closeButton}
                              onClick={() => handleCloseFrequencyRow(index)}
                              disabled={
                                equipmentSubTypeVariantData.oisd_frequencies
                                  .length === 1
                              }
                            >
                              ❌
                            </button>
                          </div>

                          <label style={styles.label}>
                            Frequencies (As per OISD)
                          </label>
                          <div style={styles.rowGroup}>
                            <input
                              type="text"
                              name="OISDPoint"
                              placeholder="Enter OISD Point"
                              value={frequency.OISDPoint}
                              onChange={(e) =>
                                handleFrequencyChange(
                                  index,
                                  "OISDPoint",
                                  e.target.value
                                )
                              }
                              style={{ ...styles.input, flex: "1 1 200px" }}
                            />
                            <input
                              type="number"
                              name="Frequency"
                              placeholder="Frequency (in days)"
                              value={frequency.Frequency}
                              onChange={(e) =>
                                handleFrequencyChange(
                                  index,
                                  "Frequency",
                                  e.target.value
                                )
                              }
                              style={{ ...styles.input, flex: "1 1 200px" }}
                            />
                          </div>

                          <textarea
                            rows={3}
                            value={frequency.Description}
                            onChange={(e) =>
                              handleFrequencyChange(
                                index,
                                "Description",
                                e.target.value
                              )
                            }
                            placeholder="Description"
                            style={styles.textarea}
                          />

                          <label style={styles.label}>OISD Document</label>
                          <Select
                            id="category"
                            options={category}
                            value={frequency.category}
                            onChange={(selectedOption) =>
                              handlecategoryChange(selectedOption, index)
                            }
                            placeholder="Select Category"
                          />
                        </div>
                      )
                    )}

                  <div style={{ textAlign: "right" }}>
                    <button
                      type="button"
                      style={styles.button}
                      onClick={handleAddFrequencyRow}
                    >
                      ➕ Add Frequency
                    </button>
                  </div>
                </div> */}

                <div className="form-group-select frequency-type">
                  <label htmlFor="ContactNo">Rule Type</label>
                  <div className="tab-wrapper" ref={containerRef}>
                    <Tabs
                      value={tabValue}
                      onChange={handleTabChange}
                      aria-label="report tabs"
                      className="custom-tabs"
                    >
                      <Tab
                        className={`config-tab ${
                          tabValue === 0 ? "selected" : ""
                        }`}
                        label="OISD"
                      />
                      <Tab
                        className={`config-tab ${
                          tabValue === 1 ? "selected" : ""
                        }`}
                        label="Factory Act"
                      />
                      <Tab
                        className={`config-tab ${
                          tabValue === 2 ? "selected" : ""
                        }`}
                        label="OEM Recommendation"
                      />
                      <Tab
                        className={`config-tab ${
                          tabValue === 3 ? "selected" : ""
                        }`}
                        label="PESO"
                      />
                      {projectType === "ATF" && (
                        <Tab
                          className={`config-tab ${
                            tabValue === 4 ? "selected" : ""
                          }`}
                          label="AQCAM"
                        />
                      )}
                    </Tabs>
                  </div>
                </div>
                
                {tabValue === 0 && (
                  <div>
                    {equipmentSubTypeVariantData.oisd_frequencies.map(
                      (frequency, index) => (
                        <>
                          <div className="form-group">
                            <label htmlFor="oisd_no">OISD No</label>
                            <div className="input-group1">
                              <input
                                type="text"
                                name="oisd_no"
                                value={frequency.oisd_no}
                                onChange={(e) =>
                                  handleFrequencyChange(
                                    index,
                                    "oisd_no",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter OISD no"
                              />
                              <button
                                className="add-close-button"
                                type="button"
                                onClick={() => handleCloseFrequencyRow(index)}
                                disabled={
                                  equipmentSubTypeVariantData.oisd_frequencies
                                    .length === 1
                                }
                              >
                                <IoClose className="frequency-close-icon" />
                              </button>
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="frequencies">
                              Frequencies (As per OISD){" "}
                            </label>
                            <div className="new-frequency-row">
                              <>
                                <div
                                  key={index}
                                  className="frequency-row input-group"
                                >
                                  <input
                                    type="text"
                                    className="point-fr"
                                    name="OISDPoint"
                                    placeholder="Enter OISD Point"
                                    value={frequency.OISDPoint}
                                    onChange={(e) =>
                                      handleFrequencyChange(
                                        index,
                                        "OISDPoint",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <input
                                    type="number"
                                    name="Frequency"
                                    placeholder="Frequency (in days)"
                                    value={frequency.Frequency}
                                    onChange={(e) =>
                                      handleFrequencyChange(
                                        index,
                                        "Frequency",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <textarea
                                    type="message"
                                    rows={4}
                                    cols={1}
                                    className="textarea"
                                    value={frequency.Description}
                                    onChange={(e) =>
                                      handleFrequencyChange(
                                        index,
                                        "Description",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Description"
                                  />
                                </div>
                              </>
                            </div>
                          </div>
                          <div className="form-group-select">
                            <label htmlFor="category">OISD Document</label>
                            <Select
                              id="category"
                              options={category}
                              value={frequency.category} // Set the selected category for this row
                              onChange={
                                (selectedOption) =>
                                  handlecategoryChange(selectedOption, index) // Pass the index for specific row
                              }
                              placeholder="Select Category"
                              isSearchable
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  backgroundColor:
                                    theme === "dark" ? "black" : "white", // Dropdown background color
                                  color: theme === "dark" ? "#fff" : "#333", // Text color
                                  borderColor:
                                    theme === "dark" ? "#444" : "#ccc", // Border color
                                  cursor: "pointer",
                                  boxShadow: "none",
                                  "&:hover": {
                                    borderColor:
                                      theme === "dark" ? "#666" : "#888", // Border color on hover
                                  },
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  backgroundColor:
                                    theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                                  border: `1px solid ${
                                    theme === "dark" ? "#444" : "#ccc"
                                  }`, // Border for the menu
                                  borderRadius: "4px", // Optional: add border radius for rounded edges
                                  zIndex: 1000, // Ensures the menu appears above other elements
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isFocused
                                    ? "#666" // Gray when hovered
                                    : theme === "dark"
                                    ? "#000"
                                    : "#fff", // Black background for options in dark mode
                                  color: state.isFocused
                                    ? "#fff"
                                    : theme === "dark"
                                    ? "#fff"
                                    : "#333", // Text color
                                  cursor: "pointer",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                                }),
                              }}
                            />
                          </div>
                          {/* {frequency.category &&
                            frequency.category.filename && (
                              <div className="form-group">
                                <label htmlFor="category">Selected File</label>
                                <div className="attachment-items">
                                  {frequency.category.filename}
                                </div>
                              </div>
                            )} */}
                        </>
                      )
                    )}

                    <div className="add-new-frequency">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddFrequencyRow}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                )}

                {tabValue === 1 && (
                  <div>
                    {equipmentSubTypeVariantData.factory_act_frequencies.map(
                      (frequency, index) => (
                        <>
                          <div className="form-group">
                            <label htmlFor="factory_act_rule_no">
                              Rule No:
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                name="factory_act_rule_no"
                                value={frequency.factory_act_rule_no}
                                onChange={(e) =>
                                  handleFectoryActChange(
                                    index,
                                    "factory_act_rule_no",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter factory act rule no"
                              />
                            </div>
                            <button
                              className="add-close-button"
                              type="button"
                              onClick={() => handleCloseFectoryActRow(index)}
                              disabled={
                                equipmentSubTypeVariantData
                                  .factory_act_frequencies.length === 1
                              }
                            >
                              <IoClose className="frequency-close-icon" />
                            </button>
                          </div>

                          <div className="form-group">
                            <label htmlFor="freuqency">Frequency</label>
                            <div className="input-group">
                              <input
                                type="number"
                                name="freuqency"
                                value={frequency.Frequency}
                                onChange={(e) =>
                                  handleFectoryActChange(
                                    index,
                                    "Frequency",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter freuqency (in days)"
                              />
                            </div>
                          </div>
                        </>
                      )
                    )}
                    <div className="add-new-frequency">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddFactoryActRow}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                )}

                {tabValue === 2 && (
                  <div>
                    {equipmentSubTypeVariantData.oem_frequencies.map(
                      (frequency, index) => (
                        <>
                          <div className="form-group">
                            <label htmlFor="Frequency">Frequency</label>
                            <div className="input-group">
                              <input
                                type="number"
                                name="Frequency"
                                value={frequency.Frequency}
                                onChange={(e) =>
                                  handleOEMChange(
                                    index,
                                    "Frequency",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter frequency (in days)"
                              />
                            </div>
                            <button
                              className="add-close-button"
                              type="button"
                              onClick={() => handleCloseOEMRow(index)}
                              disabled={
                                equipmentSubTypeVariantData.oem_frequencies
                                  .length === 1
                              }
                            >
                              <IoClose className="frequency-close-icon" />
                            </button>
                          </div>
                        </>
                      )
                    )}
                    <div className="add-new-frequency">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddOEMRow}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                )}

                {tabValue === 3 && (
                  <div>
                    {equipmentSubTypeVariantData.peso_frequencies.map(
                      (frequency, index) => (
                        <>
                          <div className="form-group">
                            <label htmlFor="peso_rule_no">Rule No</label>
                            <div className="input-group">
                              <input
                                type="text"
                                name="peso_rule_no"
                                value={frequency.peso_rule_no}
                                onChange={(e) =>
                                  handlePESOChange(
                                    index,
                                    "peso_rule_no",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter peso rule no"
                              />
                            </div>
                            <button
                              className="add-close-button"
                              type="button"
                              onClick={() => handleClosePesoRow(index)}
                              disabled={
                                equipmentSubTypeVariantData.peso_frequencies
                                  .length === 1
                              }
                            >
                              <IoClose className="frequency-close-icon" />
                            </button>
                          </div>

                          <div className="form-group">
                            <label htmlFor="Frequency">Frequency</label>
                            <div className="input-group">
                              <input
                                type="number"
                                name="Frequency"
                                value={frequency.Frequency}
                                onChange={(e) =>
                                  handlePESOChange(
                                    index,
                                    "Frequency",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter frequency (in days)"
                              />
                            </div>
                          </div>
                        </>
                      )
                    )}
                    <div className="add-new-frequency">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddPESORow}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                )}

                {projectType === "ATF" && tabValue === 4 && (
                  <div>
                    {equipmentSubTypeVariantData.car_frequencies.map(
                      (frequency, index) => (
                        <>
                          <div className="form-group">
                            <label htmlFor="oisd_no">AQCAM No</label>
                            <div className="input-group1">
                              <input
                                type="text"
                                name="car_rule_no"
                                value={frequency.car_rule_no}
                                onChange={(e) =>
                                  handleCARFrequencyChange(
                                    index,
                                    "car_rule_no",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter AQCAM no"
                              />
                              <button
                                className="add-close-button"
                                type="button"
                                onClick={() => handleCloseCARRow(index)}
                                disabled={
                                  equipmentSubTypeVariantData.car_frequencies
                                    .length === 1
                                }
                              >
                                <IoClose className="frequency-close-icon" />
                              </button>
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="frequencies">
                              Frequencies (As per AQCAM){" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="new-frequency-row">
                              <>
                                <div
                                  key={index}
                                  className="frequency-row input-group"
                                >
                                  <input
                                    type="text"
                                    className="point-fr"
                                    name="car_point"
                                    placeholder="Enter AQCAM Point"
                                    value={frequency.car_point}
                                    onChange={(e) =>
                                      handleCARFrequencyChange(
                                        index,
                                        "car_point",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <input
                                    type="number"
                                    name="Frequency"
                                    placeholder="Frequency (in days)"
                                    value={frequency.Frequency}
                                    onChange={(e) =>
                                      handleCARFrequencyChange(
                                        index,
                                        "Frequency",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <textarea
                                    type="message"
                                    rows={4}
                                    cols={1}
                                    className="textarea"
                                    value={frequency.car_description}
                                    onChange={(e) =>
                                      handleCARFrequencyChange(
                                        index,
                                        "car_description",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Description"
                                  />
                                </div>
                                {departmentError && (
                                  <span className="error-message">
                                    {departmentError}
                                  </span>
                                )}
                              </>
                            </div>
                          </div>
                          <div className="form-group-select">
                            <label htmlFor="category">AQCAM Document</label>
                            <Select
                              id="category"
                              options={category}
                              value={frequency.category} // Set the selected category for this row
                              onChange={
                                (selectedOption) =>
                                  handleCARcategoryChange(selectedOption, index) // Pass the index for specific row
                              }
                              placeholder="Select Category"
                              isSearchable
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  backgroundColor:
                                    theme === "dark" ? "black" : "white", // Dropdown background color
                                  color: theme === "dark" ? "#fff" : "#333", // Text color
                                  borderColor:
                                    theme === "dark" ? "#444" : "#ccc", // Border color
                                  cursor: "pointer",
                                  boxShadow: "none",
                                  "&:hover": {
                                    borderColor:
                                      theme === "dark" ? "#666" : "#888", // Border color on hover
                                  },
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  backgroundColor:
                                    theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                                  border: `1px solid ${
                                    theme === "dark" ? "#444" : "#ccc"
                                  }`, // Border for the menu
                                  borderRadius: "4px", // Optional: add border radius for rounded edges
                                  zIndex: 1000, // Ensures the menu appears above other elements
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isFocused
                                    ? "#666" // Gray when hovered
                                    : theme === "dark"
                                    ? "#000"
                                    : "#fff", // Black background for options in dark mode
                                  color: state.isFocused
                                    ? "#fff"
                                    : theme === "dark"
                                    ? "#fff"
                                    : "#333", // Text color
                                  cursor: "pointer",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                                }),
                              }}
                            />
                          </div>
                          {/* {frequency.category &&
                            frequency.category.filename && (
                              <div className="form-group">
                                <label htmlFor="category">Selected File</label>
                                <div className="attachment-items">
                                  {frequency.category.filename}
                                </div>
                              </div>
                            )} */}
                        </>
                      )
                    )}

                    <div className="add-new-frequency">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddCARFrequencyRow}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                )}

                {/* {tabValue === 4 && (
                  <div>
                    {equipmentSubTypeVariantData.car_frequencies.map(
                      (frequency, index) => (
                        <>
                          <div className="form-group">
                            <label htmlFor="oisd_no">CAR No</label>
                            <div className="input-group1">
                              <input
                                type="text"
                                name="car_rule_no"
                                value={frequency.car_rule_no}
                                onChange={(e) =>
                                  handleCARFrequencyChange(
                                    index,
                                    "car_rule_no",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter CAR no"
                              />
                              <button
                                className="add-close-button"
                                type="button"
                                onClick={() => handleCloseCARRow(index)}
                                disabled={
                                  equipmentSubTypeVariantData.car_frequencies
                                    .length === 1
                                }
                              >
                                <IoClose className="frequency-close-icon" />
                              </button>
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="frequencies">
                              Frequencies (As per CAR){" "}
                            </label>
                            <div className="new-frequency-row">
                              <>
                                <div
                                  key={index}
                                  className="frequency-row input-group"
                                >
                                  <input
                                    type="text"
                                    className="point-fr"
                                    name="car_point"
                                    placeholder="Enter CAR Point"
                                    value={frequency.car_point}
                                    onChange={(e) =>
                                      handleCARFrequencyChange(
                                        index,
                                        "car_point",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <input
                                    type="number"
                                    name="Frequency"
                                    placeholder="Frequency (in days)"
                                    value={frequency.Frequency}
                                    onChange={(e) =>
                                      handleCARFrequencyChange(
                                        index,
                                        "Frequency",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <textarea
                                    type="message"
                                    rows={4}
                                    cols={1}
                                    className="textarea"
                                    value={frequency.car_description}
                                    onChange={(e) =>
                                      handleCARFrequencyChange(
                                        index,
                                        "car_description",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Description"
                                  />
                                </div>
                              </>
                            </div>
                          </div>
                          <div className="form-group-select">
                            <label htmlFor="category">CAR Document</label>
                            <Select
                              id="category"
                              options={category}
                              value={frequency.category} // Set the selected category for this row
                              onChange={
                                (selectedOption) =>
                                  handleCARcategoryChange(selectedOption, index) // Pass the index for specific row
                              }
                              placeholder="Select Category"
                              isSearchable
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  backgroundColor:
                                    theme === "dark" ? "black" : "white", // Dropdown background color
                                  color: theme === "dark" ? "#fff" : "#333", // Text color
                                  borderColor:
                                    theme === "dark" ? "#444" : "#ccc", // Border color
                                  cursor: "pointer",
                                  boxShadow: "none",
                                  "&:hover": {
                                    borderColor:
                                      theme === "dark" ? "#666" : "#888", // Border color on hover
                                  },
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  backgroundColor:
                                    theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                                  border: `1px solid ${
                                    theme === "dark" ? "#444" : "#ccc"
                                  }`, // Border for the menu
                                  borderRadius: "4px", // Optional: add border radius for rounded edges
                                  zIndex: 1000, // Ensures the menu appears above other elements
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isFocused
                                    ? "#666" // Gray when hovered
                                    : theme === "dark"
                                    ? "#000"
                                    : "#fff", // Black background for options in dark mode
                                  color: state.isFocused
                                    ? "#fff"
                                    : theme === "dark"
                                    ? "#fff"
                                    : "#333", // Text color
                                  cursor: "pointer",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                                }),
                              }}
                            />
                          </div>
                        </>
                      )
                    )}

                    <div className="add-new-frequency">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddCARFrequencyRow}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                )} */}
              </div>
            </form>

            {showDepartmentPopup && (
              <div className="inquiry-customerperson-popup">
                <AddDepartmentPopup
                  closePopup={closeDepartmentPopup}
                  setSelectedDepartment={setSelectedDepartment}
                  handleNewDepartment={handleNewDepartment}
                />
              </div>
            )}
            {showSubDepartmentPopup && (
              <div className="inquiry-customerperson-popup">
                <AddSubDepartmentPopup
                  closePopup={closeSubDepartmentPopup}
                  selectedDepartment={selectedDepartment}
                  parentSelectedDepartment={selectedDepartment}
                  handleNewSubDepartment={handleNewSubDepartment}
                />
              </div>
            )}
            {showequipmentTypePopup && (
              <div className="inquiry-customerperson-popup">
                <AddEquipmentType
                  closePopup={closeEquipmentTypePopup}
                  setSelectEdequipmentType={setSelectEdequipmentType}
                  handleNewEquipmentType={handleNewEquipmentType}
                  parentSelectedDepartment={selectedDepartment}
                  parentSelectedSubDepartment={selectedSubDepartment}
                />
              </div>
            )}
            {showSubTypePopup && (
              <div className="inquiry-customerperson-popup">
                <AddEquipmentSubType
                  closePopup={closeSubTypePopup}
                  setSelectedEquipmentSubType={setSelectedEquipmentSubType}
                  parentSelectedEquipmentType={selectedEquipmentTypes}
                  handleNewEquipmentSubType={handleNewEquipmentSubType}
                />
              </div>
            )}
            {showSubTypeVariantPopup && (
              <div className="inquiry-customerperson-popup">
                <AddSubTypeVariant
                  closePopup={closeEquipmentTypeVariantPopup}
                  setSelectEdequipmentTypeVariants={
                    selectedEquipmentSubTypeVariants
                  }
                  handleNewEquipmentSubTypeVariant={
                    handleNewEquipmentSubTypeVariant
                  }
                  parentSelectedEquipmentSubType={selectedEquipmentSubType}
                />
              </div>
            )}
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="save"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(40px)", marginLeft: "15px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default FrequencyConfig;
